import React from 'react';
import { UiKit } from '@datavant/uikit';
import { VStack } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ECWPremiseModal = (props: { onClose: () => void; isOpen: boolean }) => {
    const onClick = () => {
        const url =
            'https://bookings.cloud.microsoft/book/DatavantSiteConnectROIAgentInstallation@datavant.com/?ismsaljsauthenabled=true';
        window.open(url, '_blank');
    };

    const ModalBody = (
        <VStack width={'100%'} alignItems={'left'}>
            <UiKit.Text.BodyRegularBold>
                To move forward with Autofulfill setup, please schedule your installation appointment. In
                addition to the requirements outlined in the scheduling link, the following is needed:
            </UiKit.Text.BodyRegularBold>
            <UiKit.Chakra.UnorderedList>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>
                        Your practice's IT contact creates a read only SQL user account to EHR Database and a
                        Windows Domain User account.
                    </UiKit.Text.BodyRegular>
                </UiKit.Chakra.ListItem>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>
                        Your practice's IT contact identifies or creates a windows server with access to the
                        source EHR database.
                    </UiKit.Text.BodyRegular>
                </UiKit.Chakra.ListItem>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>
                        During the call our team will walk your practice's IT contact through installing the
                        site connector and adjusting the windows user to only have access to the areas where
                        scanned documents are stored.
                    </UiKit.Text.BodyRegular>
                </UiKit.Chakra.ListItem>
            </UiKit.Chakra.UnorderedList>
            <UiKit.Text.BodyRegular>
                Prefer a pre-installation call? Email us at requestmanager@datavant.com
            </UiKit.Text.BodyRegular>
        </VStack>
    );

    const ModalFooter = (
        <UiKit.Chakra.VStack>
            <UiKit.Chakra.HStack w={'full'} justifyContent={'flex-end'} spacing={UiKit.consistency.buffer}>
                <UiKit.Button.Cancel text={'Not Now'} onClick={props.onClose} />
                <UiKit.Button.Primary
                    text="Schedule Installation"
                    onClick={onClick}
                    rightIcon={<FontAwesomeIcon icon={UiKit.Icons.FontAwesome.solid.faArrowRight} />}
                />
            </UiKit.Chakra.HStack>
        </UiKit.Chakra.VStack>
    );

    return (
        <UiKit.Modal
            title={'Schedule Installation'}
            bodyFragment={ModalBody}
            footerFragment={ModalFooter}
            onClose={props.onClose}
            isOpen={props.isOpen}
            size={'2xl'}
            fullScreen={false}
        />
    );
};
